// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vx","title":"vy","year":"vz","genres":"vA","buttonWrapper":"vB","button":"vC xr"};